import { StatusLabel } from './table-cell-label';

export { StatusLabel };
